import { FxIdWebFeaturesProfileGetResponse } from "@app/shared/api/gen";
import { fetchProfileData } from "@entities/user/api/fetchProfileData.ts";
import { authTokenExists } from "@shared/api/Auth.ts";
import log from "loglevel";

/**
 * Асинхронно получает данные профиля пользователя. Возвращает undefined если токена нет
 */
export const fetchProfileDataIfAvailable = async (
	gameSystemName: string | undefined,
	forceRefetch = false
): Promise<FxIdWebFeaturesProfileGetResponse | undefined> => {
	if (!authTokenExists()) {
		log.debug("No auth token for profile to get");
		return Promise.resolve(undefined);
	}

	return fetchProfileData(gameSystemName, forceRefetch);
};
